import type { ReactNode } from 'react';
import { Typography } from '@src/components/Typography/Typography';
import './InlineCode.css';

export interface InlineCodeProps {
  children: ReactNode;
}

export function InlineCode({ children }: InlineCodeProps) {
  return (
    <Typography as="code" role="meta/mono" className="inline-code">
      {children}
    </Typography>
  );
}
